var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "noviceGuidance" },
    [
      _vm._l(_vm.list, function (item, i) {
        return [
          _vm.index === i
            ? _c(
                "div",
                {
                  key: i,
                  staticClass: "posit",
                  style: { right: item.right, bottom: item.bottom },
                },
                [
                  _c(
                    "div",
                    { class: ["item", item.arrowClass ? item.arrowClass : ""] },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                      item.tips
                        ? _c("div", { staticClass: "tips" }, [
                            _vm._v(_vm._s(item.tips)),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "msg" }, [
                        _vm._v(
                          " 新增GPT-4，以及视频文案提取和AI图片生成功能，助力快速创作文稿。点击我进入伏羲云AI助手主页，开启你的AI之旅！ "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "bottom_row" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "next",
                              attrs: { type: "primary" },
                              on: { click: _vm.next },
                            },
                            [_vm._v(" 我知道了 ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }